export default {
  noDataMessage: { id: 'data_unavailable' },
}
